<template>
  <div class="hvh-multy-switch">
    <slot></slot>
    <a class="hvh-circle" ref="badge"></a>
  </div>
</template>

<script>
import { propToBool } from '../../../../libraries/common';
export default {
  methods: {
    width() {
      return `${(100 / this.slots().length)}%`;
    },
    redrawBadge() {
      var checked = this.slots().find(f => f.data && f.data.attrs && propToBool(f.data.attrs.checked));

      var activeIndex = this.slots().indexOf(checked);
      this.$refs.badge.style.left = `${(100 / this.slots().length * activeIndex)}%`;
      this.$refs.badge.style.width = this.width();
      this.$refs.badge.style.display = activeIndex < 0 ? 'none' : 'flex';
      this.$refs.badge.title = checked ? (checked.data.attrs.title || '') : '';
    },
    changeSlotsStyle() {
      var width = this.width();
      this.slots().forEach(slot => {
        slot.data = slot.data || {};
        slot.data.style = { ...(slot.data.style || {}), width };
        slot.data.class = {
          ...(slot.data.class || {}),
          'hvh-switch-clicked': propToBool((slot.data.attrs || {}).checked)
        };
      });
    },
    slots() {
      return this.$slots.default.filter(f => f.tag);
    }
  },
  beforeUpdate() {
    this.redrawBadge();
    this.changeSlotsStyle();
  },
  beforeMount() {
    this.changeSlotsStyle();
  },
  mounted() {
    this.redrawBadge();
  }
}
</script>


<style>
.hvh-multy-switch {
  position: relative;
  min-height: 5px;
  padding: 2px;
  background-color: #f0f0f0;
  -webkit-box-shadow: 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.4) inset;
  box-shadow: inset 0 2px 3.8px 0.2px rgba(0, 0, 0, 0.4);
  border-radius: 40px;
  overflow: hidden;
}

.hvh-multy-switch,
.hvh-multy-switch .hvh-circle {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.hvh-multy-switch .hvh-circle {
  position: absolute;
  left: 0;
  top: 0;
  padding: 0;
  border-radius: 50%;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  z-index: 2;
}

.hvh-multy-switch .hvh-btn {
  display: inline-block;
  margin: 0;
  padding: 3px;
  background: transparent;
  border: none;
  border-radius: 40px;
  font-size: 1.1em;
  font-weight: 400;
  text-align: center;
  color: #666;
  line-height: 1.5;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-transition: background 0.15s ease-in-out;
  transition: background 0.15s ease-in-out;
}

.hvh-multy-switch .hvh-switch-clicked {
  background: #195d6f;
  color: #fff;
  -webkit-transition: background 0.3s linear;
  transition: background 0.3s linear;
}

.hvh-multy-switch .hvh-btn + .hvh-btn {
  margin: 0;
}

.hvh-multy-switch .hvh-icons {
  line-height: 0;
}
</style>